import { render } from "./ProveedoresPage.vue?vue&type=template&id=3c752b42"
import script from "./ProveedoresPage.vue?vue&type=script&lang=js"
export * from "./ProveedoresPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__